import { rankingData } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-600',
  down: 'ri-arrow-down-line text-foreground-400',
  same: 'ri-subtract-line text-foreground-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {rankingData.title}
          </h2>
          <p className="text-sm text-foreground-600">实时追踪一区二区及每日大赛热门内容</p>
        </div>
        <div className="bg-background-50 rounded-xl overflow-hidden">
          {rankingData.items.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors ${
                idx < rankingData.items.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 truncate">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.zone}</span>
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-foreground-700 whitespace-nowrap">
                <span>{item.hot}</span>
              </div>
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className={trendIcons[item.trend] || trendIcons.same}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}